import { primaryColor } from '../locatorDriftConstants';

export const screenDriftTabStyles = {
  controlsPaper: {
    p: 2,
  },
  compareButton: {
    bgcolor: primaryColor,
    '&:hover': { bgcolor: '#3d2a70' },
  },
  filterRow: {
    flexWrap: 'wrap',
  },
};

export const driftTableStyles = {
  details: {
    p: 0,
  },
  clickableRow: (ignored) => ({
    cursor: 'pointer',
    opacity: ignored ? 0.55 : 1,
  }),
  locatorCell: {
    maxWidth: 260,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontFamily: 'monospace',
  },
  detailCell: {
    bgcolor: '#FAFBFC',
  },
};

export const driftDetailStyles = {
  pageSourceButton: {
    alignSelf: 'flex-start',
  },
};

export const suggestionPanelStyles = {
  root: {
    p: 1.5,
  },
  title: {
    mb: 1,
  },
  card: {
    p: 1.5,
    bgcolor: '#fff',
  },
  header: {
    mb: 1,
  },
  alternatives: {
    mt: 1,
  },
  alternativeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    p: 0.75,
    bgcolor: '#F7F8FA',
    borderRadius: 1,
  },
  strategy: {
    width: 110,
  },
  code: {
    flex: 1,
    fontFamily: 'monospace',
    wordBreak: 'break-all',
  },
};

export const driftSummaryColors = {
  regression: '#dc2626',
  fixed: '#16a34a',
  new: '#2563eb',
  removed: '#d97706',
};
